import React, { useState, useEffect } from 'react'
import { CButton, CCard, CCardBody, CModal, CModalHeader, CModalTitle, CModalBody, CModalFooter, CContainer, CRow, CTable, CTableHead, CTableRow, CTableHeaderCell, CTableBody, CTableDataCell, CBadge, CCol } from '@coreui/react'
import CustomAgGrid from './../../components/shared/CustomAgGrid'
import ImagingDetails from './ImagingDetails'
import ImagingInformation from '../../services/general/ImagingAPI.api.js'
import GetDiagnosisData from '../../services/general/getDiagnosisData.api'
import './Imaging.css'
import ImagingCarder from '../../components/shared/ImagingCarder'
import Pageloader from '../../components/shared/Pageloader'
import { SaveActivity } from './save-activity'

const Imaging = () => {
  const [imagingData, setImagingData] = useState([])
  const [modalVisible, setModalVisible] = useState(false)
  const [isEditing, setIsEditing] = useState(false)
  const [currentImagingId, setCurrentImagingId] = useState(-1)
  const [selectedImaging, setSelectedImaging] = useState(null)
  const [diagnosisData, setDiagnosisData] = useState([])

  const [allDiagnosis, setAllDiagnoses] = useState([])
  const [isShuffling, setIsShuffling] = useState(false)
  const [newImagingData, setNewImagingData] = useState(null)
  const [boxView, setBoxView] = useState('box')
  const [askDeleteModal, setAskDeleteModal] = useState(false)
  const [deleteInfo, setDeleteInfo] = useState({ id: null, priority: null }) // New state for delete confirmation
  const [isPageLoading, setIsPageLoading] = useState(false)
  const [file, setFile] = useState([])
  const [reasonList, setReasonList] = useState([{ diagnosis: '', reason: '' }])
  const getDiagnosisData = async () => {
    let a = await GetDiagnosisData()
    let data = JSON.parse(a.d)
    setAllDiagnoses(data.Data)
    const allDiagnosis = data.Data.map((item) => ({
      value: item.id,
      label: item.Name.trim(),
    }))
    setDiagnosisData(allDiagnosis)
  }

  const deleteImaging = async (id, priority) => {
    const findGreaterExists = imagingData
      .filter((item) => {
        return item.ID !== id && Number(item.Priority) >= Number(priority)
      })
      .map((item) => {
        return { ...item, priority: Number(item.priority), Keywords: JSON.stringify(item.Keywords) }
      })

    if (findGreaterExists.length > 0) {
      for (let item of findGreaterExists) {
        item.Priority = Number(item.Priority) - 1
        item.Keywords = JSON.stringify(item.Keywords)
        await ImagingInformation('UPDATE', item.Name, item.Priority.toString(), item.Keywords, item.ID)
      }
    }

    try {
      await ImagingInformation('DELETE', '', '', '', id)
      const updatedImaging = imagingData.filter((img) => img.ID !== id)
      setImagingData(updatedImaging)
    } catch (error) {
      console.error('Error deleting imaging data', error)
    }
    getData()
  }

  const handleEditImaging = (imaging) => {
    setIsEditing(true)
    setCurrentImagingId(imaging.ID)
    setSelectedImaging(imaging)
    setModalVisible(true)
    setFile(imaging.ExtraData || [])
    try {
      setReasonList(imaging.ReasonList ? JSON.parse(imaging.ReasonList) : [])
    } catch (error) {
      setReasonList([])
    }
  }

  const rowClicked = (type, rowClicked) => {
    if (type == 'EDIT') {
      handleEditImaging(rowClicked)
    } else if (type == 'DELETE') {
      deleteImaging(rowClicked.ID, rowClicked.priority)
    }
  }

  const buttonList = [{ Name: 'Edit' }, { Name: 'Delete' }]

  const handleOnClick = () => {
    setIsEditing(false)
    setCurrentImagingId(null)
    setSelectedImaging(null)
     setFile([])
  setReasonList([{ diagnosis: '', reason: '' }])
  setModalVisible(true)
  }

  const saveImaging = async (newImagingData, isNewEditing = true, formattedJsonString, file) => {
    let allData = updateDiagnosisData(newImagingData, allDiagnosis)
    const findGreaterExists = imagingData.filter((item) => Number(item.Priority) > Number(newImagingData?.priority))
    if (findGreaterExists.length > 0 && isNewEditing) {
      setIsShuffling(true)
      setNewImagingData(newImagingData)
    } else {
      try {
        if (isEditing) {
          await ImagingInformation('UPDATE', newImagingData.name, newImagingData.priority, newImagingData.Keywords, currentImagingId, formattedJsonString, JSON.stringify(file), newImagingData.ImagingReason,
 newImagingData.ImagingCode)
        } else {
         await ImagingInformation(
 'INSERT',
 newImagingData.name,
 newImagingData.priority,
 newImagingData.Keywords,
 '',
 formattedJsonString,
 JSON.stringify(file),
 newImagingData.ImagingReason,
 newImagingData.ImagingCode
)
         // await ImagingInformation('INSERT', newImagingData.name, newImagingData.priority, newImagingData.Keywords, '', formattedJsonString, JSON.stringify(file))
        }
        getData()
        setModalVisible(false)
        setFile([])
      } catch (error) {
        console.error('Error saving imaging data', error)
      }
    }
  }

  const handleShuffleConfirm = async () => {
    setIsPageLoading(true)
    const findGreaterExists = imagingData
      .filter((item) => item.ID !== newImagingData.ID && Number(item.Priority) >= Number(newImagingData.priority))
      .map((item) => {
        return { ...item, priority: Number(item.priority), Keywords: JSON.stringify(item.Keywords) }
      })

    try {
      if (isEditing) {
        await ImagingInformation('UPDATE', newImagingData.name, newImagingData.priority, newImagingData.Keywords, newImagingData.ID, '', JSON.stringify(file))
        for (let item of findGreaterExists) {
          item.Priority = Number(item.Priority) + 1
          item.Keywords = JSON.stringify(item.Keywords)
          await ImagingInformation('UPDATE', item.Name, item.Priority.toString(), item.Keywords, item.ID)
        }
      } else {
        await ImagingInformation('INSERT', newImagingData.name, newImagingData.priority, newImagingData.Keywords, '', '', JSON.stringify(file))

        for (let item of findGreaterExists) {
          item.Priority = Number(item.Priority) + 1
          item.Keywords = JSON.stringify(item.Keywords)
          await ImagingInformation('UPDATE', item.Name, item.Priority.toString(), item.Keywords, item.ID)
        }
      }
      getData()
      setIsShuffling(false)
      setModalVisible(false)
      setIsPageLoading(false)
      setFile([])
    } catch (error) {
      console.error('Error saving imaging data', error)
    }
  }

  const handleShuffleCancel = () => {
    setIsShuffling(false)
    setModalVisible(false)
    setNewImagingData(null)
    setIsEditing(false)
  }

  useEffect(() => {
    getDiagnosisData()
  }, [])

  const getData = async () => {
    setIsPageLoading(true)
    try {
      const data = await ImagingInformation('GET_ALL')
      if (data) {
        const formattedData = JSON.parse(data.d)?.Data
        const allFormattedData = formattedData.map((item) => {
          let parsedKeywords

          try {
            if (item.Keywords) {
              parsedKeywords = JSON.parse(item.Keywords)
            } else {
              parsedKeywords = []
            }
          } catch (e) {
            parsedKeywords = item.Keywords ? item.Keywords.split(',').map((keyword) => keyword.trim()) : []
          }
          try {
            return {
              ...item,
               ExtraData: (() => {
    try {
      return item.ExtraData ? JSON.parse(item.ExtraData) : []
    } catch {
      return []
    }
  })(),
              Keywords: JSON.parse(JSON.parse(item.Keywords)),

              // Keywords: JSON.parse(JSON.parse(item.Keywords)),

              //imaging details edit button crash fix MIHIR
              //for some keyword it is JSON string of array and for some it is double encoded json, so added a check if it is double encoded json then the parsed data becomes string, if it is so then parse it again
              Keywords: (() => {
                try {
                  let parsed = JSON.parse(item.Keywords)

                  if (typeof parsed === 'string') {
                    parsed = JSON.parse(parsed)
                  }

                  return Array.isArray(parsed) ? parsed : []
                } catch {
                  return []
                }
              })(),
            }
          } catch (e) {
            return {
              ...item,
              //   ExtraData: (() => {
              //     try {
              //       return item?.ExtraData ? JSON.parse(item.ExtraData) : {}
              //       return Array.isArray(parsed) ? parsed : []
              //     } catch {
              //       return {}
              //     }
              //   })(),
              ExtraData: (() => {
                try {
                  const parsed = item?.ExtraData ? JSON.parse(item.ExtraData) : []
                  return Array.isArray(parsed) ? parsed : [] // ← force array, not {}
                } catch {
                  return [] // ← was returning {}, change to []
                }
              })(),
              Keywords: (() => {
                try {
                  return item?.Keywords ? JSON.parse(item.Keywords) : []
                } catch {
                  return []
                }
              })(),
            }
          }
        })

        setImagingData(allFormattedData.sort((a, b) => a.Priority - b.Priority))
      }
    } catch (error) {
      console.error('Error fetching imaging data', error)
    } finally {
      setIsPageLoading(false)
    }
  }

  function updateDiagnosisData(inputData, diagnosisData) {
    // Parse the Keywords JSON from the input data (double parsing due to double encoding)
    const keywordsList = JSON.parse(JSON.parse(inputData.Keywords))

    // Create a map to collect keywords for each diagnosis
    const diagnosisKeywordsMap = {}

    // Loop through each item in the keywords list
    keywordsList.forEach((item) => {
      const diagnosisIds = item.diagnosis.split(',').map((id) => parseInt(id))
      const newKeywords = item.keyword.split(',')

      diagnosisIds.forEach((diagnosisId) => {
        if (!diagnosisKeywordsMap[diagnosisId]) {
          diagnosisKeywordsMap[diagnosisId] = new Set()
        }

        newKeywords.forEach((keyword) => {
          diagnosisKeywordsMap[diagnosisId].add(keyword)
        })
      })
    })

    // Update the diagnosis data with new keywords
    const modifiedDiagnoses = []
    diagnosisData.forEach((diagnosisEntry) => {
      const diagnosisId = diagnosisEntry.id
      if (diagnosisKeywordsMap[diagnosisId]) {
        const existingKeywords = new Set(diagnosisEntry.Keywords.split(','))
        let modified = false

        // Add new keywords if they are not already present
        diagnosisKeywordsMap[diagnosisId].forEach((keyword) => {
          if (!existingKeywords.has(keyword)) {
            existingKeywords.add(keyword)
            modified = true
          }
        })

        // Update the diagnosis entry with the new keywords if modified
        if (modified) {
          diagnosisEntry.Keywords = Array.from(existingKeywords).join(',')
          modifiedDiagnoses.push(diagnosisEntry)
        }
      }
    })

    return modifiedDiagnoses
  }

  const handleDeleteImaging = (idx, id, priority) => {
    setAskDeleteModal(true)
    setDeleteInfo({ id, priority })
  }

  const handleContinueDeleteImaging = async () => {
    await deleteImaging(deleteInfo.id, deleteInfo.priority)
    setDeleteInfo({ id: null, priority: null })
    setAskDeleteModal(false)
    SaveActivity('Deleted Imaging')
  }

  useEffect(() => {
    getData()
  }, [])

  return (
    <>
      <div className="position-relative imaging-theme">
        <Pageloader isLoading={isPageLoading} />

        <CCard className="m-2 master-grid-theme__toolbar imaging-theme__toolbar">
          <CCardBody className="master-grid-theme__toolbar-body imaging-theme__toolbar-body">
            <div className="d-flex gap-1 align-items-center justify-content-between">
              <CButton className="m-2 imaging-theme__add-btn" variant="outline" onClick={handleOnClick}>
                + Add Imaging
              </CButton>
            </div>
          </CCardBody>
        </CCard>

        {boxView === 'list' ? (
          <CRow xs={{ gutterX: 2, gutterX: 2 }} className="p-2 master-grid-theme__box-list imaging-theme__detail-list">
            {imagingData.length > 0 &&
              imagingData.map((imaging, index) => (
                <div className="col-sm-12 mb-3 mb-sm-0" key={index}>
                  <div className="card imaging-theme__detail-card">
                    <div className="card-body imaging-theme__detail-card-body">
                      <p className="mb-3">
                        Name :<b>{imaging.Name}</b>{' '}
                      </p>
                      <p className="mb-3">
                        Priority : <b>{imaging.Priority}</b>
                      </p>
                      <CTable>
                        <CTableHead>
                          <CTableRow>
                            <CTableHeaderCell scope="col">Diagnosis</CTableHeaderCell>
                            <CTableHeaderCell scope="col">Keywords</CTableHeaderCell>
                            <CTableHeaderCell scope="col">Remarks</CTableHeaderCell>
                          </CTableRow>
                        </CTableHead>
                        <CTableBody>
                          {imaging?.Keywords?.length > 0 &&
                            imaging?.Keywords?.map((item, itemIndex) => (
                              <CTableRow key={itemIndex}>
                                <CTableDataCell valign="middle">
                                  <p className="d-flex align-items-center m-0 gap-2">
                                    {item.diagnosis.split(',').map((diagnosis, diagnosisIndex) => {
                                      const diagnosisItem = diagnosisData.find((items) => items.value === parseInt(diagnosis.trim()))
                                      return (
                                        <span key={diagnosisIndex} className=" bg-opacity-25 rounded-pill text-bg-primary diagnosis-imaging">
                                          <CBadge>{diagnosisItem ? diagnosisItem.label : diagnosis}</CBadge>
                                        </span>
                                      )
                                    })}
                                  </p>
                                </CTableDataCell>
                                <CTableDataCell valign="middle">
                                  <p className="m-0 d-flex align-items-center gap-2 keywords-wrap">{item.keyword}</p>
                                </CTableDataCell>
                                <CTableDataCell valign="middle">
                                  <p className="remarks-wrap">{item.remarks}</p>
                                </CTableDataCell>
                              </CTableRow>
                            ))}
                        </CTableBody>
                      </CTable>
                      <div className="d-flex gap-2 inline">
                        <CButton variant="outline" color="primary" onClick={() => handleEditImaging(imaging)}>
                          Edit
                        </CButton>
                        <CButton
                          variant="outline"
                          onClick={() => {
                            handleDeleteImaging(index, imaging.ID, imaging.Priority)
                          }}
                          color="danger"
                        >
                          Delete
                        </CButton>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
          </CRow>
        ) : (
          <CRow xs={{ gutterX: 2 }} className="p-2 master-grid-theme__box-list imaging-theme__box-list">
            {imagingData.length > 0 &&
              imagingData.map((imaging, index) => (
                <CCol xs={4} className="mb-3 mb-sm-0" key={index}>
                  <ImagingCarder
                    editFunc={() => handleEditImaging(imaging)}
                    deleteFunc={() => {
                      handleDeleteImaging(index, imaging.ID, imaging.Priority)
                    }}
                    counts={imaging.Priority}
                    heading={imaging.Name}
                  ></ImagingCarder>
                </CCol>
              ))}
          </CRow>
        )}

        {imagingData.length < 0 && (
          <section style={{ height: '35rem' }} className="mx-2 imaging-theme__empty-state d-flex justify-content-center align-items-center">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="text-center">
                    <h3 className="h2 mb-2">No Data Available</h3>
                    <p className="mb-5">The information you are looking for is currently not available.</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}

        {/* <CustomAgGrid rowClickedFn={rowClicked} callFrom="Imaging" options={imagingData} btnList={buttonList} /> */}

        <CModal
          backdrop="static"
          className="shuffleModalContainer patient-theme-modal imaging-theme__modal"
          size="md"
          // onClose={}
          visible={isShuffling}
        >
          <CModalHeader>
            <CModalTitle>Priority Shuffle Mode</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <p>Are you sure, you want to reshuffle the imaging order?</p>
          </CModalBody>
          <CModalFooter>
            <CButton variant="outline" onClick={handleShuffleCancel} color="secondary">
              No
            </CButton>
            <CButton variant="outline" onClick={handleShuffleConfirm} color="primary">
              Yes
            </CButton>
          </CModalFooter>
        </CModal>

        <CModal
          size="xl"
          className="patient-theme-modal imaging-theme__modal"
          visible={modalVisible}
          onClose={() => {
            ;(setModalVisible(false), setFile([]))
          }}
          backdrop="static"
          keyboard={false}
        >
          <CModalHeader
            onClose={() => {
              ;(setModalVisible(false), setFile([]))
            }}
          >
            <CModalTitle>{isEditing ? 'Edit Imaging' : 'Add Imaging'}</CModalTitle>
          </CModalHeader>
          <CModalBody>
            {modalVisible && (
              <ImagingDetails
                diagnosisData={diagnosisData}
                setImagingData={setImagingData}
                imagingData={selectedImaging}
                allImgings={imagingData}
                saveImagingFn={saveImaging}
                ButtonName={isEditing ? 'Update' : 'Save'}
                isEditing={isEditing}
                selectedImaging={selectedImaging}
                setIsEditing={setIsEditing}
                reasonList={reasonList}
                setReasonList={setReasonList}
                onClose={setModalVisible}
                file={file}
                setFile={setFile}
              />
            )}
          </CModalBody>
        </CModal>

        <CModal
          className="patient-theme-modal imaging-theme__modal"
          visible={askDeleteModal}
          onClose={() => {
            setAskDeleteModal(false)
            setDeleteInfo({ id: null, priority: null })
          }}
        >
          <CModalHeader>
            <CModalTitle>Delete Imaging</CModalTitle>
          </CModalHeader>
          <CModalBody className="p-0 m-0">
            <p className="p-4 m-0">Are you sure, you want to delete the imaging ?</p>
          </CModalBody>
          <CModalFooter className="m-0">
            <CButton
              onClick={() => {
                setAskDeleteModal(false)
              }}
              color="secondary"
              className="ui-action-btn ui-action-btn--secondary"
            >
              Close
            </CButton>
            <CButton onClick={handleContinueDeleteImaging} color="danger" className="text-white ui-action-btn ui-action-btn--danger" style={{ color: '#ffffff' }}>
              Delete
            </CButton>
          </CModalFooter>
        </CModal>
      </div>
    </>
  )
}

export default Imaging
